
import Card from "./Card";
import { Column, Row } from "./Layout";
import { Box } from "@mui/material";
import RegionSelector from "./RegionSelector";
import SignOutButton from "./SignOutButton";
import { useAuth } from "../hooks/useAuth";
import TextLabel from "./typography/TextLabel";
import TextHero from "./typography/TextHero";

export default function Header() {
    // const { headerText } = useHeaderTextStore()

    const { user } = useAuth()



    return (
        <Row alignItems={"stretch"} justifyContent={"space-between"} >
            <Column className="w-3/12" justifyContent={"stretch"}>
                <Card className="h-full" fullWidth>
                    <img style={{ objectFit: "contain", maxWidth: "200px " }} src="/images/sauron.png" />

                </Card>
            </Column>
            <Column className="w-9/12" justifyContent={"center"} flexGrow={1}>
                <Card fullWidth>

                    <Row alignItems={"center"}>

                        <Column className="w-3/12">
                        </Column>

                        <Column className="w-6/12">
                            <RegionSelector />
                        </Column>

                        <Column className="w-3/12" alignItems={"flex-end"} pr="18px">
                            <TextLabel>{user?.email}</TextLabel>
                            <Box maxWidth={"200px"} width="100%">
                                <SignOutButton />
                            </Box>
                        </Column>

                    </Row>

                </Card>
            </Column>

        </Row >
    )
}